import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-platform-tour-modal',
  templateUrl: './platform-tour-modal.component.html',
  styleUrls: ['./platform-tour-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'platform-tour-modal'
  }
})
export class PlatformTourModalComponent {
  constructor(private activeModal: NgbActiveModal) {}
  public closeModal(): void {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/platform-tour/platform-tour-modal/platform-tour-modal.component.ts